import View            from '@widesk-ui/components/View';
import React           from 'react';
import useDesignTokens from '@/hooks/useDesignTokens';

const Kbd = ({ children, active }: { children: React.ReactNode; active?: boolean; }) => {
	const tokens = useDesignTokens();

	return (
		<View
			px={6}
			br={4}
			bold
			size={12}
			color={active ? tokens.color.primary : tokens.text.secondary}
			bg={active ? `color-mix(in srgb, ${tokens.color.primary} 15%, transparent)` : tokens.fill.tertiary}
			style={{
				border: `1px solid ${active ? tokens.color.primary : tokens.border.default}`,
				lineHeight: '18px',
				transition: 'all .15s ease',
			}}
		>
			{children}
		</View>
	);
};

export default Kbd;
